import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Archive_notification() {
    const navigate = useNavigate();
    const [listNotification, setListNotification] = useState([]);
    const [totalmessage, setTotalmessage] = useState(0);
    const [unreadCount, setUnreadCount] = useState(0);
    const [notificationID, setNotificationID] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];

        const isSuperAdmin = storedPermissions.includes("notification.view_all");

        const trgval = isSuperAdmin
            ? localStorage.getItem('mem_company_id')
            : localStorage.getItem('member_id');

        const adminmember = isSuperAdmin ? "Super Admin" : "Member";

        var obj = {
            trgid: trgval,
            usertype: adminmember
        };

        fetch('getAllNotifications.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.json()) // IMPORTANT: parse JSON
            .then(parsedResult => {
                console.log(parsedResult);

                try {
                    const total = parsedResult.filter(item => item.is_delete == 1).length;
                    setTotalmessage(total);

                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListNotification(parsedResult);

                        const unread = parsedResult.filter(item => item.is_read == 0).length;
                        setUnreadCount(unread);
                    } else {
                        showAlert('No notification found.');
                        setListNotification([]);
                    }

                } catch (e) {
                    console.error(e);
                    showAlert('Failed to load notification data.');
                    setListNotification([]);
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
                showAlert('Server error while fetching notifications.');
            });
    }, [])

    function restoreItem(item) {
        setNotificationID(item.id)
        var msg = 'This action will restore the archived notification again to your inbox. Would you really want to restore it?'
        openConfAlert(msg);
    }


    function openConfAlert(msg) {
        $('#confpop').css('display', 'block');
        $('#confalert_text').text(msg);
    }
    function closeConf() {
        $('#confpop').css('display', 'none');
        $('#confalert_text').text('');
    }

    function restoreNotificationRow() {
        var obj = {
            notiid: notificationID,
        }
        console.log(obj)

        $.ajax({
            type: 'POST',
            url: 'changeStatusIsRestore.php',
            data: obj,
            cache: false,
            success: function (result) {
                closeConf();
                // ✅ Update state immediately
                setListNotification(prevList =>
                    prevList.map(item =>
                        item.id == notificationID
                            ? { ...item, is_delete: 0 }
                            : item
                    )
                );

            },
        });
    }


    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs fullwidth pull_left'>Archive<span>({totalmessage} total message)</span></h2>

                    <Link className='pull_right add_new_pro' to="/inbox">Inbox</Link>
                </div>
                <section className='vl_dsh_bodypart_section'>
                    <div className='vl_dsh_container'>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_full listrow'>
                                <table>
                                    {listNotification
                                        .filter(item => item.is_delete == 1)
                                        .map((listnotification, index) => {



                                            return (
                                                <tr
                                                    key={listnotification.id}
                                                    className={listnotification.is_read == 0 ? "unread-row" : "read-row"}
                                                >
                                                    <td className='pr-40'>{listnotification.title}</td>
                                                    <td className='pr-40'>Created By {listnotification.creator_name}</td>
                                                    <td className='pr-40'>{listnotification.created_at}</td>

                                                    <td className='pr-40'>
                                                        {/* View */}
                                                        <span className='catbtn viewbtn pr-40'>
                                                            <button onClick={() => restoreItem(listnotification)}>
                                                                <i className='ri-eye-line'></i> Restore
                                                            </button>
                                                        </span>

                                                        {/* Archive (Delete for Me) */}


                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>

            <div className='vl_dsh_popup' id="confpop">
                <div className='alertbox h200'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="confalert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button className='greenbtn' onClick={restoreNotificationRow}>Yes</button>
                        <button className='ml-10' onClick={closeConf}>No</button>
                    </div>

                </div>
            </div>
        </div>
    )
}
